import { render, staticRenderFns } from "./groupDoctorList.vue?vue&type=template&id=7fe9dddc&scoped=true&"
import script from "./groupDoctorList.vue?vue&type=script&lang=ts&"
export * from "./groupDoctorList.vue?vue&type=script&lang=ts&"
import style0 from "./groupDoctorList.vue?vue&type=style&index=0&id=7fe9dddc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe9dddc",
  null
  
)

export default component.exports